import { createAction, props } from '@ngrx/store';
import { Note } from '../../notes/note';
import { NoteTableFilter } from './note.reducers';

// fetch notes
export const fetchNotes = createAction('[note] fetch');
export const getNotesSuccess = createAction(
  '[note] get notes success',
  props<{ notes: Note[] }>()
);
export const getNotesError = createAction(
  '[note] get notes failed',
  props<{ error: any }>()
);

// load notes
export const fetchNotesDetail = createAction(
  '[Notes] Fetch notes detail',
  props<{ noteId: string }>()
);
export const notesDetailLoaded = createAction(
  '[Notes] Load notes detail',
  props<{ note: Note }>()
);
export const notesDetailLoadError = createAction(
  '[Notes] Load notes detail error',
  props<{ error: any }>()
);

// add notes
export const noteSubmitted = createAction(
  '[notes] note submit request',
  props<{ note: Note }>()
);
export const noteSubmitOk = createAction(
  '[notes] note submit success',
  props<{ data: any }>()
);
export const noteSubmitError = createAction(
  '[notes] note submit failed',
  props<{ error: any }>()
);

// edit notes
export const editNote = createAction(
  '[notes] note edit request',
  props<{ note: Note }>()
);
export const editNoteOk = createAction(
  '[notes] note edit success',
  props<{ data: Note }>()
);
export const editNoteError = createAction(
  '[notes] note edit failed',
  props<{ error: any }>()
);

// delete notes
export const deleteNoteRequest = createAction(
  '[notes] delete note request',
  props<{ id: string }>()
);
export const deleteNoteSucess = createAction(
  '[notes] delete note success',
  props<{ result: any }>()
);
export const deleteNoteError = createAction(
  '[notes] delete note failed',
  props<{ error: any }>()
);

export const updateTableFilter = createAction(
  '[notes] update table filter',
  props<{ tableFilter: NoteTableFilter }>()
);
